var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// React
import React from 'react';
// Material ui
import Grid from '@material-ui/core/Grid/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
// Component
import ComponentForm from '../ComponentForm';
import RadioForm from '../RadioForm/RadioForm';
// Styles
import { styles } from './radioGroupForm.style';
// Models
import { Box } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
/**
 * RadioGroupForm component
 */
var RadioGroupForm = /** @class */ (function (_super) {
    __extends(RadioGroupForm, _super);
    /**
     * RadioGroupForm constructor
     * @param props
     */
    function RadioGroupForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRadioUpdateChange = function (id, value) {
            if (_this.state.value !== id) {
                _this.setState({ value: id });
                _this.props.onChange('keyValue', [_this.props.id, value]);
            }
        };
        _this.state = { value: _this.props.initialValue };
        return _this;
    }
    RadioGroupForm.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.reset !== this.props.reset && this.props.reset) {
            this.setState({ value: '' });
        }
    };
    /**
     * Render method
     */
    RadioGroupForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, classes = _a.classes, visible = _a.visible, error = _a.error, helperText = _a.helperText, required = _a.required;
        var containerClass = classes ? classes.container : '';
        if (!visible) {
            return null;
        }
        return (React.createElement(FormControl, { fullWidth: true, required: required, className: containerClass, margin: "normal", error: error },
            React.createElement(Grid, { container: true, spacing: 3, justify: "center" }, options.map(function (option) {
                return React.createElement(Grid, { item: true, key: option.value },
                    React.createElement(RadioForm, { visible: true, id: option.value, required: false, checked: _this.state.value === option.value, onChange: _this.handleRadioUpdateChange, initialValue: option.value || option.label, name: option.label, label: option.label, assetUrl: _this.props.assetUrl }));
            })),
            error
                ? React.createElement(FormHelperText, null,
                    React.createElement(Box, { textAlign: "center", m: 1 }, helperText))
                : null));
    };
    return RadioGroupForm;
}(ComponentForm));
export default withStyles(styles)(RadioGroupForm);
//# sourceMappingURL=RadioGroupForm.js.map